module.exports = __webpack_public_path__ + "img/03-04-img-1@2x.31974a17.png";